function _addLeadingZeroes(num) {
    return ('' + num).padStart(2, '0');
}

function dateFormat(date) {
    return _addLeadingZeroes(date.getDate()) + "." +
        _addLeadingZeroes(date.getMonth() + 1) + "." +
        date.getFullYear() + " " +
        _addLeadingZeroes(date.getHours()) + ":" +
        _addLeadingZeroes(date.getMinutes());
}

function localDateFormat(date) {
    return _addLeadingZeroes(date.getDate()) + "." +
        _addLeadingZeroes(date.getMonth() + 1) + "." +
        date.getFullYear()
}

function isoDateFormat(date) {
    //YYYY-MM-DD
    return date.getFullYear() + "-" + _addLeadingZeroes(date.getMonth() + 1) + "-" + _addLeadingZeroes(date.getDate())
}

function calculateAge(date) {
    let today = new Date();

    return calculateAgeAtDate(date, today);
}

function calculateAgeAtDate(patientBirthDate, targetDate) {
    let birthDate = new Date(patientBirthDate);
    let targetDateVar = new Date(targetDate);

    let age = targetDateVar.getFullYear() - birthDate.getFullYear();
    let month = targetDateVar.getMonth() - birthDate.getMonth();
    if (month < 0 || (month === 0 && targetDateVar.getDate() < birthDate.getDate())) {
        age--;
    }
    return age;
}

export {_addLeadingZeroes, dateFormat, localDateFormat, isoDateFormat, calculateAge, calculateAgeAtDate}